export interface ScreenResolutionTier {
  label: '720p' | '1080p' | '2K' | '4K';
  width: number;
  height: number;
  frameRate: { ideal: number; max: number };
  bitrates: {
    low: number;
    standard: number;
    high: number;
    HD: number;
  };
}

export const SCREEN_SHARE_RESOLUTION_TIERS: Record<string, ScreenResolutionTier> = {
  '720p': {
    label: '720p',
    width: 1280,
    height: 720,
    frameRate: { ideal: 15, max: 30 },
    bitrates: { low: 200000, standard: 500000, high: 1200000, HD: 1500000 },
  },
  '1080p': {
    label: '1080p',
    width: 1920,
    height: 1080,
    frameRate: { ideal: 24, max: 30 },
    bitrates: { low: 300000, standard: 800000, high: 2500000, HD: 3000000 },
  },
  '2K': {
    label: '2K',
    width: 2560,
    height: 1440,
    frameRate: { ideal: 30, max: 30 },
    bitrates: { low: 500000, standard: 1200000, high: 4000000, HD: 5000000 },
  },
  '4K': {
    label: '4K',
    width: 3840,
    height: 2160,
    frameRate: { ideal: 30, max: 30 },
    bitrates: { low: 800000, standard: 2000000, high: 6000000, HD: 8000000 },
  },
};

export function detectMonitorResolution(): { width: number; height: number } {
  const dpr = window.devicePixelRatio ?? 1;
  return {
    width: Math.round(window.screen.width * dpr),
    height: Math.round(window.screen.height * dpr),
  };
}

export function getResolutionTier(width: number, height: number): ScreenResolutionTier {
  if (height <= 720 || width <= 1280) {
    return SCREEN_SHARE_RESOLUTION_TIERS['720p'];
  }
  if (height <= 1080 || width <= 1920) {
    return SCREEN_SHARE_RESOLUTION_TIERS['1080p'];
  }
  if (height <= 1440 || width <= 2560) {
    return SCREEN_SHARE_RESOLUTION_TIERS['2K'];
  }
  return SCREEN_SHARE_RESOLUTION_TIERS['4K'];
}

export function getResolutionTierFromScreen(): ScreenResolutionTier {
  const { width, height } = detectMonitorResolution();
  return getResolutionTier(width, height);
}
